import axios from 'axios'
import {getApiUrls,getApiUpdateUrls} from "@/http/base.http";

export function getAssetType(payload) {
const { env } = getApiUrls();
    return axios.post(`${env}asset/type/get`, payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function addAssetType(payload) {
const { env } = getApiUrls();
    return axios.post(`${env}asset/type/add`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function getByIdAssetType(id) {
const { env } = getApiUrls();
    return axios.get(`${env}asset/type/detail/${id}`).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}

export function updateAssetType(payload) {
const {envU } = getApiUpdateUrls();
    return axios.put(`${envU}asset/type/update`,payload).then(res => {
        axios.defaults.baseURL = res.data
        return res.data
    })
}
